import LogoutIcon from "@mui/icons-material/Logout";
import { Avatar, ListItemIcon, ListItemText } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "../Assets/images/logo.svg";
import ailogo from "../Assets/images/sm-logo.svg";

export default function ButtonAppBar({ onLogout }) {
  const session = JSON.parse(localStorage.getItem("session"));

  // Preload the logo images
  useEffect(() => {
    const link1 = document.createElement("link");
    link1.rel = "preload";
    link1.as = "image";
    link1.href = logo;
    document.head.appendChild(link1);

    const link2 = document.createElement("link");
    link2.rel = "preload";
    link2.as = "image";
    link2.href = ailogo;
    document.head.appendChild(link2);

    return () => {
      document.head.removeChild(link1);
      document.head.removeChild(link2);
    };
  }, []);

  if (session) {
    const { employeeName } = session;

    const abbreviation = () => {
      const words = employeeName.split(" ");
      const ab = words.map((word) => word[0].toUpperCase()).join("");
      return ab;
    };

    const ab = abbreviation();

    const handleLogout = () => {
      localStorage.clear();
      sessionStorage.clear();
      if (onLogout) {
        onLogout();
      }
    };

    return (
      <Box sx={{ flexGrow: 1 }} id="header">
        <AppBar className="wbg">
          <Toolbar>
            <Box sx={{ flexGrow: 1 }}>
              <Link to="/">
                <img src={logo} alt="logo" className="logo" loading="eager" />
                <img src={ailogo} alt="ailogo" className="ailogo" loading="eager" />
              </Link>
            </Box>

            <Box className="fx_fe ai_center">
              <Box mr={1}>
                <ListItemIcon className="avtar_dp_icon">
                  <Avatar className="avtar_dp">{ab}</Avatar>
                </ListItemIcon>
              </Box>
              <Box className="avtar_dp_name" mr={2}>
                <ListItemText primary={employeeName} />
              </Box>
              <Box>
                <Link to="/signin">
                  <IconButton onClick={handleLogout}>
                    <LogoutIcon fontSize="medium" className="col1" />
                  </IconButton>
                </Link>
              </Box>
            </Box>
          </Toolbar>
        </AppBar>
      </Box>
    );
  }
}
